
<div class="wrapper" position="fixed" fxLayout="row" fxLayoutAlign="center">

    <div *ngIf="auth.user$ | async as user; else signIn" fxLayout="column" fxFlex="100">
      
        <app-navigation-bar></app-navigation-bar>

      <!-- <pre>{{user | json}}</pre> -->
    </div>
  
<ng-template #signIn>
    <div class="container">
        
        <div class="center">
          <h1>Welcome to <strong>Exchange4Students!</strong></h1>
          <br>
          <div class="row">
            <div class="column">
                <img src="https://firebasestorage.googleapis.com/v0/b/exchange4students.appspot.com/o/images%2FPrice_Tag.PNG?alt=media&token=26fb9612-6531-4cc1-b9fd-0e035cfac3d9" alt="Price Tag" width="200" height="200">
                <h4>Buy what you need</h4>
            </div>
            <div class="column">
                <img src="https://firebasestorage.googleapis.com/v0/b/exchange4students.appspot.com/o/images%2FPackage.PNG?alt=media&token=cbdc7b21-612d-48e6-9e1d-6ecd41b8e67b" alt="Package" width="200" height="200">
                <h4>Sell what you don't</h4>
            </div>
            
            <div class="column">
                <img src="https://firebasestorage.googleapis.com/v0/b/exchange4students.appspot.com/o/images%2FStevens.PNG?alt=media&token=2a1e9398-302b-4085-96f4-6fc1bdd7f96a" alt="Stevens" width="200" height="200">
                <h4>All on Stevens Marketplace!</h4>
            </div>
            
          </div>
          <br>
          <button mat-raised-button (click)="auth.googleLogin()">Sign In with Google</button>
        </div>
            
    </div>
</ng-template>
  
    <!-- <router-outlet></router-outlet> -->
  
</div>
